import { Autocomplete, GoogleMap, LoadScript, useJsApiLoader } from '@react-google-maps/api';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { GOOGLE_API_KEY, GOOGLE_API_LIBRARY } from '../../utils/constants';
import { setOnboardingInfo } from '../../store/slice/onboarding/slice';

const GoogleMaps = ({ setPlaceId, centerLat, centerLong, viewOnly }) => {
  let [searchParams] = useSearchParams();
  const tabParam = searchParams.get('step');
  const dispatch = useDispatch();

  const containerStyle = {
    width: '100%',
    height: +tabParam === 2 ? 'auto' : 400,
    borderRadius: 10,
    shadowColor: 'rgba(0,0,0,1)',
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 1,
    elevation: 4,
    shadowRadius: 8,
  };
  //   const { isLoaded } = useJsApiLoader({
  //     id: 'google-map-script',
  //     googleMapsApiKey: GOOGLE_API_KEY,
  //   });

  const [center, setCenter] = useState({
    lat: centerLat ?? 40.7591192,
    lng: centerLong ?? -74.0104303,
    zoom: 5,
  });
  const [searchResult, setSearchResult] = useState('');
  const [map, setMap] = useState(null);

  const onLoadMap = useCallback(function callback(map) {
    map.setZoom(15);
    setMap(map);
  }, []);

  const onUnmountMap = useCallback(function callback(map) {
    setMap(null);
  }, []);

  useEffect(() => {
    if (map) {
      map.setOptions({ gestureHandling: viewOnly ? 'none' : 'auto' });
    }
  }, [map, viewOnly]);

  const onClick = async e => {
    if (setPlaceId) {
      setPlaceId(e.placeId);
    } else {
      dispatch(setOnboardingInfo({ googlePlaceId: e.placeId }));
    }
  };

  function onLoad(autocomplete) {
    setSearchResult(autocomplete);
  }

  function onPlaceChanged() {
    if (searchResult != null) {
      const place = searchResult.getPlace();
      setPlaceId(place.place_id);
      //   setCenter({
      //     lat: place.geometry.location.lat(),
      //     lng: place.geometry.location.lng(),
      //     zoom: 5,
      //   })
      map.setCenter({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
    } else {
      alert('Please enter text');
    }
  }
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_API_KEY,
    libraries: GOOGLE_API_LIBRARY,
  });

  return (
    <>
      {isLoaded && (
        <GoogleMap
          onClick={onClick}
          mapContainerStyle={containerStyle}
          center={center}
          zoom={5}
          options={{ ...(viewOnly && { gestureHandling: 'none' }), mapTypeControl: false }}
          defaultOptions={{}}
          onLoad={onLoadMap}
          onUnmount={onUnmountMap}>
          <Autocomplete onPlaceChanged={onPlaceChanged} onLoad={onLoad}>
            <input
              type="text"
              placeholder="Input"
              readOnly={viewOnly}
              style={{ borderRadius: 10, borderWidth: 2, borderColor: '#000' }}
            />
          </Autocomplete>
        </GoogleMap>
      )}
    </>
  );
};

export default GoogleMaps;
